export const clearStorage = () => {
    localStorage.clear();
};

export const setTokenExpiredValue = () => {
    localStorage.setItem("is_expired", true);
};

export const getTokenExpiredValue = () => {
    return localStorage.getItem("is_expired") === "true";
};
